import AuthenticatedLayout from '@/components/layouts/AuthenticatedLayout';
import { ROUTES } from '@/constants/routes';
import { Route } from 'react-router-dom';
import ProgramSettingsDocumentLinks from '@/pages/programSettings/ProgramSettingsDocumentLinks';
import ProgramSettingsGeneral from '@/pages/programSettings/ProgramSettingsGeneral';
import BrandingThemesList from '@/pages/brandingThemes/BrandingThemesList';
import BrandingThemeAdd from '@/pages/brandingThemes/BrandingThemeAdd';
import BrandingThemeEdit from '@/pages/brandingThemes/BrandingThemeEdit';
import BrandingThemeView from '@/pages/brandingThemes/BrandingThemeView';
import StaffList from '@/pages/staff/StaffList';
import StaffDetails from '@/pages/staff/StaffDetails';
import StaffEdit from '@/pages/staff/StaffEdit';
import StaffAdd from '@/pages/staff/StaffAdd';
import CompaniesListPage from '@/pages/companies/CompaniesList';
import CompanyDetailsPage from '@/pages/companies/CompanyDetails';
import CompanyAddPage from '@/pages/companies/CompanyAdd';
import CompanyEditPage from '@/pages/companies/CompanyEdit';
import TransactionReviewPage from '@/pages/transactionReview/TransactionReview';
import TransactionReviewDetailsPage from '@/pages/transactionReview/TransactionReviewDetails';
import LendingDetails from '@/pages/lending/LendingDetails';
import LendingList from '@/pages/lending/LendingList';

export const StaffRoutes = (
  <Route element={<AuthenticatedLayout />}>
    <Route path={ROUTES.STAFF} element={<StaffList />} />
    <Route path={ROUTES.STAFF_DETAILS} element={<StaffDetails />} />
    <Route path={ROUTES.STAFF_EDIT} element={<StaffEdit />} />
    <Route path={ROUTES.STAFF_ADD} element={<StaffAdd />} />

    <Route path={ROUTES.COMPANIES} element={<CompaniesListPage />} />
    <Route path={ROUTES.COMPANIES_ADD} element={<CompanyAddPage />} />
    <Route path={ROUTES.COMPANIES_DETAIL} element={<CompanyDetailsPage />} />
    <Route path={ROUTES.COMPANIES_EDIT} element={<CompanyEditPage />} />

    <Route
      path={ROUTES.TRANSACTION_REVIEW}
      element={<TransactionReviewPage />}
    />
    <Route
      path={ROUTES.TRANSACTION_REVIEW_DETAILS}
      element={<TransactionReviewDetailsPage />}
    />

    <Route path={ROUTES.LENDING} element={<LendingList />} />
    <Route path={ROUTES.LENDING_DETAILS} element={<LendingDetails />} />

    <Route path={ROUTES.BRANDING_THEMES} element={<BrandingThemesList />} />
    <Route path={ROUTES.BRANDING_THEME_ADD} element={<BrandingThemeAdd />} />
    <Route path={ROUTES.BRANDING_THEME_EDIT} element={<BrandingThemeEdit />} />
    <Route path={ROUTES.BRANDING_THEME_VIEW} element={<BrandingThemeView />} />

    <Route
      path={ROUTES.PROGRAM_SETTINGS_GENERAL}
      element={<ProgramSettingsGeneral />}
    />
    <Route
      path={ROUTES.PROGRAM_SETTINGS_DOCUMENT_LINKS}
      element={<ProgramSettingsDocumentLinks />}
    />
  </Route>
);
